import { creatorbase } from '@round/api';
import styles from './PostStatuses.module.css';

type StatusBadgeClassNameMap = {
    [K in creatorbase.PostStatus]: string;
};

const statusBadgeClassNameMap: StatusBadgeClassNameMap = {
    live: styles.live,
    planned: styles.planned,
    briefed: styles.briefed,
    draft_pending: styles.draft_pending,
    draft_received: styles.draft_received,
    redrafting: styles.redrafting,
    draft_approved: styles.draft_approved,
    to_replace: styles.to_replace,
    backup: styles.backup,
    rejected_or_declined: styles.rejected_or_declined,
};

export const getStatusBadgeClassName = (status: creatorbase.PostStatus): string => {
    return statusBadgeClassNameMap[status];
};
